export enum InheritColors {
  LifeArea = 'inherit-life-area',
  Goal = 'inherit-goal',
}
